var map = {
	"./DrLubhani/ChangeColor": [
		784,
		181
	],
	"./Ganga/ChangeColor": [
		786,
		187
	],
	"./Indus/ChangeColor": [
		788,
		200
	],
	"./Kabini/ChangeColor": [
		790,
		207
	],
	"./Kaveri/ChangeColor": [
		702,
		21
	],
	"./Luni/ChangeColor": [
		792,
		213
	],
	"./Narmada/ChangeColor": [
		794,
		216
	],
	"./Neyyar/ChangeColor": [
		796,
		223
	],
	"./Periyar/ChangeColor": [
		798,
		226
	],
	"./SAANVI/ChangeColor": [
		800,
		236
	],
	"./Sabarmathi/ChangeColor": [
		802,
		243
	],
	"./Sparsh/ChangeColor": [
		804,
		249
	],
	"./Sutlej/ChangeColor": [
		806,
		252
	],
	"./Yamuna/ChangeColor": [
		808,
		258
	],
	"./pamba/ChangeColor": [
		810,
		267
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2022;
module.exports = webpackAsyncContext;